<template>

  <div class="cr-notifications">
    <div v-if="notificationLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
    <div v-if="notificationError" class="mc-error">{{ notificationError }}</div>
    <div v-if="notificationLoaded" class="cr-container">
      <div v-if="notification.length > 0" class="cr-notifications__tools">
        <button @click="clearNotify" class="cr-button-icon cr-button-icon--red">
          Очистить список
          <svg class="cr-button-icon__icon" width="14" height="14" viewBox="0 0 14 14">
            <use xlink:href="assets/img/svg/sprite.svg#icon-cross"></use>
          </svg>
        </button>
        <button @click="checkRead" class="cr-button-icon cr-button-icon--blue">
          Отметить прочитанными
        </button>
      </div>
      <ul v-if="notification.length > 0" class="cr-notifications__list">
        <li v-for="item in notification" class="cr-notifications__item">
          <div class="cr-notification-card" :class="{'cr-notification-card--unread':item.read==0}">
            <div class="cr-notification-card__date">
              {{item.date}}
            </div>
            <div class="cr-notification-card__title">
              {{ item.title }}
            </div>
            <div class="cr-notification-card__description">
              {{ item.text }}
            </div>
            <a class="cr-notification-card__link cr-link" @click="read(item)">
              Подробнее
            </a>
          </div>
        </li>
      </ul>
      <div v-if="notification.length ==0">Уведомлений нет</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

export default {
  data: () => ({

  }),
  mounted() {

  },
  created() {
    this.fetchNotification();
  },
  computed: {
    ...mapGetters('notification', [
      'notification',
      'notificationLoading',
      'notificationError',
      'notificationLoaded'
    ]),
  },
  components: {},
  methods: {
    ...mapActions('notification', [
      'fetchNotification'
    ]),
    ...mapActions('counter', [
      'fetchCounterData'
    ]),
    read(item) {
      // Отправляем POST запрос асинхронно
      axios.post(`/api/push/${item.id}/`, null, {
            preventAbort: true
          }
      ).then(response=>{
        this.fetchCounterData(true);
      }).catch(error => {
        console.error('Ошибка при отметке уведомления как прочитанного:', error);
      });
      // Сразу выполняем переход по URL
      if (item.url) {
        this.$router.push(item.url);
      }
    },
    async clearNotify() {
      // Очищаем список уведомлений через Vuex
      this.$store.commit('notification/SET_NOTIFICATIONS', []);

      // Отправляем POST запрос
      try {
        await axios.post('/api/push/clear/');
        this.fetchCounterData(true);
      } catch (error) {
        console.error('Ошибка при очистке уведомлений:', error);
        // В случае ошибки можно восстановить список, запросив данные заново
        this.fetchNotification();
      }
    },
    checkRead() {
      // Обновляем состояние уведомлений локально
      const updatedNotifications = this.notification.map(item => ({
        ...item,
        read: 1
      }));
      this.$store.commit('notification/SET_NOTIFICATIONS', updatedNotifications);

      // Отправляем POST запрос асинхронно
      axios.post('/api/push/read/').then(response => {
        this.fetchNotification();
        this.fetchCounterData(true);
      }).catch(error => {
        console.error('Ошибка при отметке уведомлений как прочитанных:', error);
      });
    }

  },
}
</script>

